import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import './PortalModal.css';

const PortalModal = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size = 'medium',
  bodyClassName = ''
}) => {
  const modalRoot = document.getElementById('modal-root') || document.body;
  const el = useRef(document.createElement('div'));

  useEffect(() => {
    const node = el.current;
    modalRoot.appendChild(node);
    return () => {
      if (modalRoot.contains(node)) {
        modalRoot.removeChild(node);
      }
    };
  }, [modalRoot]);

  if (!isOpen) return null;

  return createPortal(
    <button className="portal-modal-overlay" onClick={onClose}>
      <button
        className={`portal-modal-content size-${size}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="portal-modal-header">
          <h3>{title}</h3>
          <button className="portal-close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className={`portal-modal-body ${bodyClassName}`}>
          {children}
        </div>
        {footer && (
          <div className="portal-modal-footer">
            {footer}
          </div>
        )}
      </button>
    </button>,
    el.current
  );
};

export default PortalModal;
